export default `
<svg
  aria-hidden="true"
  aria-label="reaction-thumbsup-selected"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <g transform="translate(12 12) scale(1.2003) translate(-18 -18.01165)">
    <path
      d="M19.4944 12.1915C20.1713 12.3268 20.6113 12.9855 20.4759 13.6625L20.4161 13.9593C20.2781 14.6544 20.0229 15.3157 19.6662 15.9171H23.4153C24.1052 15.9171 24.665 16.4769 24.665 17.1668C24.665 17.6484 24.3916 18.0676 23.9907 18.2759C24.2745 18.505 24.4567 18.8565 24.4567 19.2496C24.4567 19.8588 24.0193 20.3665 23.4439 20.4759C23.5585 20.6659 23.6236 20.8872 23.6236 21.1241C23.6236 21.6787 23.2617 22.1499 22.7618 22.3113C22.78 22.3972 22.7905 22.4884 22.7905 22.5821C22.7905 23.272 22.2307 23.8318 21.5408 23.8318H19.0023C18.5077 23.8318 18.026 23.686 17.6147 23.4126L16.6123 22.7435C15.9172 22.2801 15.5006 21.499 15.5006 20.6633V19.6662V18.4165V17.7682C15.5006 17.008 15.8469 16.292 16.4379 15.8156L16.6305 15.662C17.3205 15.11 17.7917 14.3342 17.9635 13.4698L18.0234 13.173C18.1588 12.4961 18.8175 12.0561 19.4944 12.1915ZM12.1681 16.3337H13.8344C14.2952 16.3337 14.6675 16.706 14.6675 17.1668V22.9987C14.6675 23.4595 14.2952 23.8318 13.8344 23.8318H12.1681C11.7073 23.8318 11.335 23.4595 11.335 22.9987V17.1668C11.335 16.706 11.7073 16.3337 12.1681 16.3337Z"
      fill="currentcolor"
    />
  </g>
</svg>
`;
